/**
 * الإشعارات داخل التطبيق. لا تُنشأ إشعارات لمستخدم غير مصرّح له،
 * والقراءة مقيّدة بالسياسات (selfRow) وRLS.
 */

import type { DataGateway } from '@/data/types';
import type { AppNotification } from '@/domain/types';

export async function listMyNotifications(
  gateway: DataGateway,
  companyId: string,
  limit = 100,
): Promise<AppNotification[]> {
  return gateway.table('notifications').list({
    filter: { companyId: { op: 'eq', value: companyId } },
    orderBy: [{ field: 'createdAt', direction: 'desc' }],
    limit,
  });
}

export function unreadCount(notifications: AppNotification[]): number {
  return notifications.filter((notification) => !notification.readAt).length;
}

export async function markRead(
  gateway: DataGateway,
  notificationId: string,
  actorUserId: string,
): Promise<void> {
  await gateway.commands.markNotificationRead({ notificationId, actorUserId });
}

export async function markAllRead(
  gateway: DataGateway,
  companyId: string,
  actorUserId: string,
): Promise<number> {
  return gateway.commands.markAllNotificationsRead({ companyId, actorUserId });
}

export async function sweepDueNotifications(
  gateway: DataGateway,
  companyId: string,
  actorUserId: string,
  withinHours = 24,
): Promise<number> {
  return gateway.commands.sweepMyNotifications({ companyId, actorUserId, withinHours });
}

export function notificationTarget(notification: AppNotification): string {
  return notification.taskId ? `/tasks/${notification.taskId}` : '/notifications';
}
